import { render, staticRenderFns } from "./EmpzoneSiteForm.vue?vue&type=template&id=474fe1a4&"
import script from "./EmpzoneSiteForm.vue?vue&type=script&lang=js&"
export * from "./EmpzoneSiteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474fe1a4')) {
      api.createRecord('474fe1a4', component.options)
    } else {
      api.reload('474fe1a4', component.options)
    }
    module.hot.accept("./EmpzoneSiteForm.vue?vue&type=template&id=474fe1a4&", function () {
      api.rerender('474fe1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/site/modules/EmpzoneSiteForm.vue"
export default component.exports